export default __webpack_public_path__ + "static/media/7minfitness_4@2x.603e157d.jpg";